import {
  borderRadius,
  ButtonGroup,
  SkeletonLoader,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

import { EntityHeaderWatchlist } from '~/components/entity-header-watchlist/EntityHeaderWatchlist';

export const Root = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '100px',
        borderRadius: '8px',
      },
    },
  ],
})``;

export const StyledButtonGroup = styled(ButtonGroup)`
  ${borderRadius.r3}

  ${ButtonGroup.Styles.ButtonGroupItem} {
    ${borderRadius.r2}
  }
`;

export const Container = styled.div`
  min-height: 80vh;
  display: flex;
`;

export const EmptyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  justify-content: center;
`;

export const EmptyTitle = styled.div`
  ${typographyV2.titleLg};
`;

export const StyledImg = styled.img`
  width: 146px;
  height: auto;
`;

export const Wrapper = styled.div`
  ${EntityHeaderWatchlist.Styled.ContentWrapper} {
    margin-bottom: 8px;
  }
`;
